import { defineStore } from "pinia";
import { appStorage } from "app-core";
const useModelsStore = defineStore("models", {
  state: () => {
    return {
      users: /* @__PURE__ */ new Map(),
      roles: /* @__PURE__ */ new Map(),
      sessions: /* @__PURE__ */ new Map(),
      products: /* @__PURE__ */ new Map(),
      product_categories: /* @__PURE__ */ new Map(),
      product_ingredients: /* @__PURE__ */ new Map(),
      tax_rates: /* @__PURE__ */ new Map(),
      orders: /* @__PURE__ */ new Map(),
      order_items: /* @__PURE__ */ new Map(),
      order_item_comments: /* @__PURE__ */ new Map(),
      clients: /* @__PURE__ */ new Map(),
      sectors: /* @__PURE__ */ new Map(),
      tables: /* @__PURE__ */ new Map(),
      grids: /* @__PURE__ */ new Map(),
      buttons: /* @__PURE__ */ new Map(),
      shifts: /* @__PURE__ */ new Map(),
      cash_registers: /* @__PURE__ */ new Map(),
      cash_register_transactions: /* @__PURE__ */ new Map(),
      shortcuts: /* @__PURE__ */ new Map(),
      user_transactions: /* @__PURE__ */ new Map(),
      pricelists: /* @__PURE__ */ new Map(),
      notifications: /* @__PURE__ */ new Map(),
      app_events: /* @__PURE__ */ new Map(),
      kitchen_tickets: /* @__PURE__ */ new Map(),
      order_tickets: /* @__PURE__ */ new Map(),
      terminals: /* @__PURE__ */ new Map(),
      sync_data: /* @__PURE__ */ new Map(),
      table_sessions: /* @__PURE__ */ new Map(),
      beach_zones: /* @__PURE__ */ new Map(),
      beach_bookings: /* @__PURE__ */ new Map(),
      order_requests: /* @__PURE__ */ new Map(),
      payment_sessions: /* @__PURE__ */ new Map()
    };
  },
  actions: {
    init(PayloadType2) {
      if (!PayloadType2 || !PayloadType2.model || !PayloadType2.data) return;
      const ModelClass = PayloadType2.model;
      const entity = ModelClass.entity;
      const PayloadTypeData = PayloadType2.data;
      this[entity] = /* @__PURE__ */ new Map();
      PayloadTypeData.forEach((modelData) => {
        if (modelData) {
          this[entity].set(modelData[ModelClass.primaryKey], new ModelClass(modelData));
        }
      });
    },
    create(PayloadType2) {
      if (!PayloadType2 || !PayloadType2.model || !PayloadType2.data) return;
      const ModelClass = PayloadType2.model;
      const entity = ModelClass.entity;
      const PayloadTypeData = PayloadType2.data;
      this[entity] = /* @__PURE__ */ new Map();
      PayloadTypeData.forEach((modelData) => {
        if (modelData) {
          this[entity].set(modelData[ModelClass.primaryKey], new ModelClass(modelData));
        }
      });
      this.persist(entity, [...this[entity].values()]);
    },
    insert(PayloadType2) {
      if (!PayloadType2 || !PayloadType2.model || !PayloadType2.data || !PayloadType2.data.length) return;
      const ModelClass = PayloadType2.model;
      const entity = ModelClass.entity;
      const PayloadTypeData = PayloadType2.data;
      PayloadTypeData.forEach((modelData) => {
        if (modelData) {
          const rawKey = modelData[ModelClass.primaryKey];
          const existing = rawKey !== void 0 ? this[entity].get(rawKey) : void 0;
          const mergedData = existing ? { ...existing.$toJson(), ...modelData } : modelData;
          const model = new ModelClass(mergedData);
          const key = model[ModelClass.primaryKey];
          this[entity].set(key, model);
        }
      });
      this.persist(entity, [...this[entity].values()]);
    },
    update(PayloadType2) {
      if (!PayloadType2 || !PayloadType2.model || !PayloadType2.data || !PayloadType2.data.length) return;
      const ModelClass = PayloadType2.model;
      const entity = ModelClass.entity;
      const PayloadTypeData = PayloadType2.data;
      PayloadTypeData.forEach((modelData) => {
        var _a;
        const key = modelData ? modelData[ModelClass.primaryKey] : void 0;
        if (key !== void 0 && this[entity].has(key)) {
          const updatedModelData = { ...((_a = this[entity].get(key)) == null ? void 0 : _a.$toJson()) || {}, ...modelData };
          this[entity].set(key, new ModelClass(updatedModelData));
        }
      });
      this.persist(entity, [...this[entity].values()]);
    },
    delete(PayloadType2) {
      if (!PayloadType2 || !PayloadType2.model || !PayloadType2.data) return;
      const ModelClass = PayloadType2.model;
      const entity = ModelClass.entity;
      const PayloadTypeData = PayloadType2.data;
      this[entity].delete(PayloadTypeData[ModelClass.primaryKey]);
      this.persist(entity, [...this[entity].values()]);
    },
    persist(entity, data) {
      if (entity === "order_requests") return;
      appStorage.store().setItem(`entities.${entity}`, data);
    }
  },
  getters: {
    all: (state) => (entity) => {
      return [...state[entity].values()];
    },
    find: (state) => (entity, primaryKey, id) => {
      return state[entity].get(id);
    }
  }
});
export {
  useModelsStore
};
//# sourceMappingURL=index42.js.map
